var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SchoolLeaveEntitlementTable',{attrs:{"items":_vm.items,"is-busy":_vm.isBusy,"pagination":_vm.pagination},on:{"navigateToIndividual":_vm.goToTeacherAssignment}})
}
var staticRenderFns = []

export { render, staticRenderFns }